import React, { useState } from 'react';
import AudioRecorder from '@grnhse/seedling/lib/azalea/components/audio_recorder';
import { withLocalePrefix, tList } from 'shared/utils/translation';
import styled from 'styled-components';
import {
  BodyText,
  SectionHeader,
  SubSectionHeader,
} from '@grnhse/seedling/lib/azalea/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { Collapse } from '@grnhse/seedling/lib/azalea/components/collapse';
import { Link } from '@grnhse/seedling/lib/birch/typography';

const t = withLocalePrefix('availability.candidate_pronunciation');

type Props = {
  recordingName?: string;
  recordingUrl?: string;
};

const CandidatePronunciationRecorder = (props: Props) => {
  const [showTips, setShowTips] = useState(false);

  const toggleTips = (event: any) => {
    event.preventDefault();
    setShowTips(!showTips);
  };

  return (
    <section>
      <SectionHeader>
        {t('header')} <Optional>{t('optional')}</Optional>
      </SectionHeader>
      <BodyText style={{ marginBottom: '0px' }}>{t('subheader')}</BodyText>
      <Collapse
        id="recording_tips"
        isOpened={showTips}
        // @ts-expect-error - TS2769 - No overload matches this call.
        style={{ paddingTop: '10px' }}
      >
        <SubSectionHeader>{t('tips.header')}</SubSectionHeader>
        <BodyText style={{ marginBottom: '0px' }}>
          {tList('availability.candidate_pronunciation.tips.content').map(
            (tip, index) => (
              <Tip key={index}>{tip}</Tip>
            )
          )}

          <Link
            href="https://support.greenhouse.io/hc/en-us/articles/360050488591"
            target="_blank"
            rel="noopener"
          >
            {t('tips.learn_more')}
          </Link>
        </BodyText>
      </Collapse>
      <TipsLink href="#" onClick={toggleTips} showTips={showTips}>
        {showTips ? t('hide_tips') : t('show_tips')}
      </TipsLink>
      <AudioRecorder
        recordingName={props.recordingName}
        recordingData={props.recordingUrl}
      />
    </section>
  );
};

const Tip = styled.span`
  display: block;
`;

const TipsLink = styled(Link)<{ showTips: boolean }>`
  margin-bottom: 15px;
  display: block;
  color: ${FullPalette.GREEN_700};

  ${(props) => props.showTips && 'margin-top: 15px;'}
`;
TipsLink.displayName = 'TipsLink';

const Optional = styled.span`
  color: ${FullPalette.GREY_800};
`;

export default CandidatePronunciationRecorder;
